<template>
  <div class="container" v-if="isShowYear || isShowNew">
    <div class="header">
      <div class="header_left">
        <span
          v-for="item in chatsTab"
          :key="item"
          :class="`text ${activeName != item ? 'atvieText' : ''}`"
          @click="tabTextClick(item)"
          :style="`margin-left: ${!(isShowYear && isShowNew) ? '120px' : '60px'}`"
          >{{ item }}</span
        >
      </div>
      <div class="header_right">
        <el-form :inline="true" label-width="100px">
          <el-form-item label="付款时间" v-if="activeName == '新品表现'" class="input-wrapper">
            <el-date-picker
              v-model="payStartTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              :clearable="false"
              :editable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item :label="activeName == '年度表现' ? '付款时间' : '上市时间'" class="input-wrapper">
            <el-date-picker
              @change="strartTimeChange"
              v-model="time"
              unlink-panels
              :clearable="false"
              :editable="false"
              type="daterange"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              style="width: 200px"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button class="search-btn" size="small" @click="onSearch">搜索</el-button>
            <el-button class="rest-btn" size="small" @click="resetForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <new-chats ref="newChats" v-if="activeName == '新品表现'" />
    <year-chats ref="yearChats" v-if="activeName == '年度表现'" @timeupdate="timeupdate" />
  </div>
</template>

<script>
import moment from 'moment';
import newChats from './new/new.vue';
import yearChats from './year/year.vue';
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: 'YearBehavior',
  mixins: [pagePathMixin],
  components: {
    newChats,
    yearChats,
  },
  data() {
    return {
      value1: true,
      monthlyaverageFlag: false,
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      loading5: false,
      dialogFormVisibleLeft: false,
      dialogFormVisibleRight: false,
      year: moment().year(),
      priceData: '',
      totalYear: moment().year() - 1 + '年',
      // time: {
      //   startTime: moment().startOf('year').format('YYYY-MM-DD'),
      //   endTime: moment().format('YYYY-MM-DD'),
      // },
      time: [moment().startOf('year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
      leftData: [],
      rightData: [],
      activeName: '年度表现',
      chatsTab: [],
      payStartTime: ''
    };
  },
  watch: {
    value1(nv, ov) {
      this.init3();
    },
    $route: {
      // $route可以用引号，也可以不用引号
      handler(to, from) {
        if (from && from.path && from.path == '/productLifeCycle/administration') {
          this.resetForm(); // 重置条件
        }
      },
      deep: true, // 深度监听
      immediate: true, // 第一次初始化渲染就可以监听到
    },
  },
  computed: {
    previousYear() {
      let item = JSON.parse(JSON.stringify(this.time));
      let startTime = item && item[0] ? item[0].slice(0, 4) : '';
      let endTime = item && item[1] ? item[1].slice(0, 4) : '';
      if (startTime == endTime) {
        return startTime;
      } else {
        return '';
      }
    },
    permitList() {
      return JSON.parse(localStorage.getItem('permitList'));
    },
    isShowYear() {
      let Jurisdiction = 'ec-pc-new$analysisDashboard$productAnalysis$yearBehavior$year';
      return this.permitList.includes(Jurisdiction);
    },
    isShowNew() {
      let Jurisdiction = 'ec-pc-new$analysisDashboard$productAnalysis$yearBehavior$new';
      return this.permitList.includes(Jurisdiction);
    },
  },
  mounted() {
    this.activeName = this.isShowYear ? '年度表现' : this.isShowNew ? '新品表现' : '';
    this.chatsTab = this.isShowYear && this.isShowNew ? ['年度表现', '新品表现'] : this.isShowYear ? ['年度表现'] : this.isShowNew ? ['新品表现'] : [];
    this.strartTimeChange()
    this.$nextTick((_) => {
      this.onSearch();
    });
  },
  methods: {
    strartTimeChange() {
      this.payStartTime = moment(this.time[0]).subtract(2, 'months').format('YYYY-MM-DD')
    },
    handleCategoryChange(year) {
      this.time = [year + '-01-01', year + '-12-31'];
      console.log(this.time);
      this.init();
      this.init2();
      this.init3();
    },
    resetForm() {
      this.time = [moment().startOf('year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
      this.onSearch();
    },
    onSearch() {
      let name = this.activeName == '年度表现' ? 'yearChats' : 'newChats';
      let time = {
        startTime: this.time[0],
        endTime: this.time[1],
        payStartTime: this.payStartTime
      };
      this.$refs[name].yearChange(time);
    },
    getYearData() {
      this.monthlyaverageFlag = true;
      this.$q.goodsAnalysis
        .productSaleNum()
        .then((res) => {
          this.render_distribute(res.data);
        })
        .finally((_) => {
          this.monthlyaverageFlag = false;
        });
    },
    tabTextClick(item) {
      this.activeName = item;
      this.time = [moment().startOf('year').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')];
      this.$nextTick((_) => {
        let name = item == '年度表现' ? 'yearChats' : 'newChats';
        let time = {
          startTime: this.time[0],
          endTime: this.time[1],
          payStartTime: this.payStartTime
        };
        this.$refs[name].yearChange(time);
      });
    },
    timeupdate(val) {
      this.time = val;
    },
  },
};
</script>

<style lang="stylus" scoped>
.container {
  width: 100%;
  height: calc(100vh - 67px)
  box-sizing: border-box;
  overflow: hidden
    &::before {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0px;
      top: 0px;
      content: '';
      background: url('../../../assets/images/refundKanban_img/bg.png') no-repeat center 0px;
      background-size: 100% 100%;
      opacity: 0.9;
      z-index: 0;
    }
    .header {
    width: 100%;
    height: 56px;
    display: flex;
    position: relative;

    &::before {
      content: '';
      width: 30%;
      height: 100%;
      line-height: 46px;
      position: absolute;
      left: 0;
      background: url('../../../assets/images/refundKanban_img/header.png') no-repeat center 0px;
      background-size: 100% 100%;
      z-index: 1;
    }

    &::after {
      content: '';
      width: 120%;
      height: 100%;
      position: absolute;
      top: 25px;
      right: 0;
      background: url('../../../assets/images/refundKanban_img/light.png') no-repeat center 0px;
      background-size: 100% 100%;
      z-index: 1;
    }

    .header_left {
      flex: 3;
      z-index: 3;

      .text {
        display: inline-block;
        color: #FFF;
        font-family: YouSheBiaoTiHei;
        font-size: 32px;
        margin-top: 5px;
        margin-left: 60px;
        background: linear-gradient(180deg, #C7E1FB 0%, #FFFFFF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        cursor: pointer
      }
      .text:nth-child(2) {
        margin-left: 5% !important;
      }
    }

    .header_right {
      flex: 7;
      text-align: right;
      z-index: 3

      .searchBox {
        display: flex;
        justify-content: space-between;
      }
    }
  }


}

.search-btn {
  background: #00DEFF;
  border: 1px solid #00DEFF;
  padding: 7px 10px;
  box-sizing: border-box
  border-radius: 0;
  font-size: 14px;
  color: #010425;
  cursor: pointer
}

.rest-btn {
  background: rgba(0, 222, 255, 0.1);
  border: 1px solid #00DEFF;
  color: #00DEFF;
  padding: 7px 10px;
  border-radius: 0;
  font-size: 14px;
}


.atvieText {
  opacity: .6
}

>>> .form-date-picker .el-date-editor {
  width: 123px !important;
}

>>> .el-form--inline {
  margin: 5px 10px 0 0 !important;
}

>>> .el-form--inline .el-form-item__label {
  font-family: JDLangZhengTi;
  font-weight: 400;
  font-size: 22px;
  color: #00DEFF;
  line-height: 40px;
}
>>> .el-date-editor .el-range-input {
  background: transparent;
  color: rgba(0,222,255,0.9);
  font-size: 12px;
  // font-family: PingFangSC;
  height: 22px;
  line-height: 22px

  &::placeholder {
    color: rgba(0,222,255,0.9);
    font-size: 12px;
  }
}

>>>.el-date-editor .el-range__close-icon, >>> .el-range-separator{
  height: 22px;
  line-height: 22px
  color: rgba(0,222,255,0.9);
}
>>> .el-input__inner {
  // width: 178px;
  height: 30px;
  line-height: 30px;
  background: rgba(87, 238, 243, 0.2);
  border: 1px solid rgba(9, 250, 255, 0.2);
  border-radius: 0;
  color: rgba(0, 222, 255, 0.9);
  // font-family: PingFangSC;
  position: relative;
  font-size: 12px

  &::placeholder {
    color: rgba(0, 222, 255, 0.9);
  }
}
>>> .el-icon-arrow-up:before {
  color: #09FAFF;
}
>>> .el-icon-date:before {
  color: #09FAFF;
}
>>> .input-wrapper .el-form-item__content {
  position: relative;
  line-height: 42px;
  margin-right: 20px
  z-index: 66

  &::before {
    content: '';
    position: absolute;
    top: 5px;
    left: -1px;
    height: 32px;
    width: calc(100% + 2px);
    background: linear-gradient(to top, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to right, #66FFFF, #66FFFF) left top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) right top no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to bottom, #66FFFF, #66FFFF) left bottom no-repeat, linear-gradient(to top, #66FFFF, #66FFFF) right bottom no-repeat, linear-gradient(to left, #66FFFF, #66FFFF) right bottom no-repeat;
    /* 右下 */
    opacity: 0.8;
    background-size: 1px 4px, 4px 1px, 1px 4px, 4px 1px;
    z-index: 0;
  }
}

>>>.el-date-editor .el-range__icon, .el-range-separator{
  height: 22px;
  line-height: 22px
  color: rgba(0,222,255,0.9);
}
.el-form--inline .el-form-item {
  margin:  0
}
</style>
<style scoped>
@media screen and (max-width: 1919px) {
  .container .header::before {
    width: 38%;
  }
  .header_right {
    flex: 6;
  }
  .container .header .header_left .text {
    font-size: 26px;
    margin-top: 10px;
  }
  ::v-deep .el-form--inline .el-form-item__label {
    font-size: 16px;
  }
  .float-left {
    font-size: 12px;
  }
  .top {
    height: 45%;
  }
  .bottom {
    height: calc(55% - 5px);
  }
}
</style>
